import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { layout, position } from 'styled-system';
import {
  element,
  bool,
  func,
  oneOfType,
  string,
  number,
  arrayOf,
  object,
} from 'prop-types';
import Wrapper from '../Wrapper';
import { H3 } from '../Text/Heading';
import Icon from '../Icon';

import { useWindowSize } from '../../utils';

const StyledModal = styled(Modal)`
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.24);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.primaryWhite};
  left: 50%;
  margin-right: -50%;
  transform: translate(
    -50%,
    ${({ isMobileView }) => (isMobileView ? '0' : '-50%')}
  );
  padding: 0;
  z-index: 100;
  position: absolute;
  ${layout};
  ${position};
`;

const CloseIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.greyDark};
  cursor: pointer;
`;

const ResponsiveModal = ({
  isOpen,
  onClose,
  width,
  height,
  children,
  title,
  modalStyle,
}) => {
  const { isMobileView } = useWindowSize();

  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onClose}
      width={width}
      height={height}
      top={['initial', '50%']}
      right={[0, 'auto']}
      bottom={[0, 'auto']}
      isMobileView={isMobileView}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 50,
        },
      }}
      {...modalStyle}
    >
      {title && (
        <Wrapper
          height="56px"
          boxShadow="0px 2px 6px rgba(0, 0, 0, 0.2)"
          display="flex"
          flexDirection={['row-reverse', 'row']}
          alignItems="center"
          justifyContent={['flex-end', 'space-between']}
          padding="0 24px"
        >
          <H3
            fontSize={['16px', '20px']}
            lineHeight={['20px', '26px']}
            ml={['16px', 0]}
          >
            {title}
          </H3>
          <CloseIcon icon="CloseIcon" onClick={onClose} />
        </Wrapper>
      )}
      {children}
    </StyledModal>
  );
};

ResponsiveModal.propTypes = {
  children: element,
  isOpen: bool.isRequired,
  onClose: func,
  width: oneOfType([string, number, arrayOf(string), arrayOf(number)]),
  height: oneOfType([string, number, arrayOf(string), arrayOf(number)]),
  title: string,
  modalStyle: object,
};

ResponsiveModal.defaultProps = {
  onClose: () => {},
};

export default ResponsiveModal;
